import React from "react";
import Icon from "@material-ui/core/Icon";

/**
 * <AddButton style={object (optional)} addItem={Function}  />
 **/
const AddButton = (props) => {
  const style = props.style
    ? props.style
    : { fontWeight: 800, fontSize: "2em" };
  return (
    <button className="btn btn-link" onClick={props.addItem}>
      <Icon className="text-primary" style={style}>
        add
      </Icon>
    </button>
  );
};

export default AddButton;
